export const LOGO_DEFAULT_FILL_COLOR = "#80D9FF";